export const CORS_PROXY = "/proxy/";

export function addProxyToUrl(url: string) {
	return CORS_PROXY + url;
}

export function proxiedFetch(url: string, options?: RequestInit) {
	return fetch(addProxyToUrl(url), options);
}
